

<div class="login-container">
  <mat-card class="login-card">
    <h2>MKT Столбови</h2>

    <form [formGroup]="loginForm">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Корисничко име</mat-label>
        <input matInput formControlName="username" />
      <button 
      mat-icon-button
       matSuffix
       type="button"
      (click)="clearUser()">
         <mat-icon>close</mat-icon>
    </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width password">
        <mat-label>Лозинка</mat-label>
        <input matInput formControlName="password" type="password" 
        [type]="hide ? 'password' : 'text'"/>
            <button 
      mat-icon-button
       matSuffix
       type="button"
      (click)="hide = !hide">
        <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
      </mat-form-field>

   

      <button mat-raised-button color="primary" class="login-button" type="submit" 
      (click)="logIn()">
        НАЈАВИ СЕ
      </button>
 <div class="forgot-password">
        <a (click)="forgotPassword()">Заборави лозинка?</a>
      </div>
    </form>
  </mat-card>
</div>


